import _Abstract from "system/abstract"

export default class Component_HoverBehaviour extends _Abstract {

  constructor(el, options)
  {
    super(el, $.extend(true, {
      type:false,
      target_selector:false,
    }, options), 'component')
    this.bindEvents()
  }
  

    bindEvents()
    {
      this.$el.hover((e) => this.onElementHovered(e));
    }


    onElementHovered(e)
    {
      switch(this.options.type)
      {
        case "focus":
        {
          this.onFocusOnElement();
          break;
        }

        case "add-class-to-other-element":
        {
          this.onAddClassToOtherElement();
          break;
        }

        default:
        {
          return false;
        }
      }
    }

    onAddClassToOtherElement()
    {
      
    }

}



/** WEBPACK FOOTER **
 ** ./components/hover-behaviour.js
 **/